import { AFFILIATE_TRACK, AffiliateTrackActions } from './types'

export const AffiliateTrackAction = (payload: string): AffiliateTrackActions => ({
  type: AFFILIATE_TRACK,
  payload
})
